import theme from '@vromo/ui/components/theme';

export default {
    overlayTitle: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'normal',
        color: theme.darkText
    },
    restaurantTitle: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        marginLeft: 16,
        color: theme.darkText
    },
    zipCodeTitle: {
        fontWeight: 'bold',
        color: theme.darkText
    },
    scrollContainer: {
        maxHeight: '250px',
        overflowY: 'auto',
        marginTop: 20,
        marginBottom: 20
    },
    overlayZipCodeList: {}
};
